<template>
	<Scatter :data="data" :options="options" />
</template>

<script>
import { Scatter } from 'vue-chartjs'
import { useChart } from '@/composables/useChart'

const ScatterChart = {
	props: ['data', 'options'],
	components: { Scatter },
	setup () {
		useChart()
	}
}

export default ScatterChart
export { ScatterChart as mdbScatterChart }
</script>
